import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  listLength: number
  bgColor?: string
  embedChatwootClick?: boolean
  isPillarType?: boolean
}

export default createStyles(
  (
    theme,
    { listLength, bgColor, embedChatwootClick, isPillarType }: StylesParams,
  ) => {
    return {
      root: {
        backgroundColor: bgColor || theme.colors.blue[0],
        paddingTop: rem(80),
        paddingBottom: rem(80),
        [theme.fn.smallerThan('sm')]: {
          paddingTop: rem(40),
          paddingBottom: rem(40),
        },
        ...(isPillarType && {
          overflow: 'hidden',
        }),
      },
      inner: {},
      header: {
        textAlign: 'center',
      },
      heading: {},
      desc: {
        ...(embedChatwootClick && {
          [theme.fn.largerThan('sm')]: {
            maxWidth: rem(744),
            margin: '0 auto',
          },
        }),
      },
      bannerItem: {
        flex: 'inherit',
        width: listLength === 1 ? '100%' : `calc((100% - 16px)/2)`,
        [theme.fn.largerThan('sm')]: {
          width: listLength === 1 ? rem(648) : `calc((100% - 72px)/4)`,
        },
        ...(embedChatwootClick && {
          width: '100%',
          [theme.fn.largerThan('sm')]: {
            width: 'calc((100% - 48px)/2)',
            maxWidth: rem(552),
          },
        }),
        [theme.fn.smallerThan('sm')]: {
          ...(isPillarType && {
            width: 280,
            flex: 'none',
          }),
        },
      },
      bannerIframe: {},
      bannerItemTitle: {
        ...(embedChatwootClick && {
          display: 'none',
        }),
      },
      bannerItemWrapper: {
        ...(embedChatwootClick && {
          background: 'transparent',
        }),
      },
      bannerList: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: rem(16),
        justifyContent:
          isPillarType || listLength >= 4 ? 'flex-start' : 'center',
        [theme.fn.largerThan('sm')]: {
          gap: rem(24),
        },
        [theme.fn.smallerThan('sm')]: {
          ...(isPillarType && {
            flexWrap: 'nowrap',
            overflowX: 'auto',
            paddingTop: 5,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 5,
            /* width */
            '::-webkit-scrollbar': {
              width: 0,
              height: 0,
            },
            /* Track */
            '::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            /* Handle */
            '::-webkit-scrollbar-thumb': {
              background: 'transparent',
            },
          }),
        },
      },
      disclaimer: {
        [theme.fn.largerThan('sm')]: {
          width:
            listLength === 1
              ? rem(648)
              : listLength === 2
              ? 'calc((100% - 24px)/2)'
              : '100%',
          margin: '0 auto',
        },
      },
      bubbleRoot: {
        position: 'relative',
      },
      bubbleInside: {
        position: 'absolute',
        left: rem(-140),
        top: rem(-60),
        border: '1px solid #029394',
        borderRadius: '64%',
        padding: rem(16),
        width: rem(250),
        height: rem(80),
        cursor: 'pointer',
        '.chatwood-icon': {
          width: rem(40),
        },
      },
      bubbleText: {
        textTransform: 'uppercase',
        color: '#029394',
      },
    }
  },
)
